<template>
  <section class="hero is-info is-fullheight-with-navbar">
    <div class="hero-body">
      <div class="container">
        <div class="columns is-centered">
          <div class="column is-6-tablet is-5-desktop is-4-widescreen">
            <form class="box" @submit.prevent="onSubmit">
              <b-field label="Крисничко име">
                <b-input ref="email" type="email" v-model="email"></b-input>
              </b-field>
              <b-field label="Лозинка">
                <b-input
                  type="password"
                  password-reveal
                  v-model="password"
                ></b-input>
              </b-field>
              <b-button native-type="submit" expanded>Пријави се</b-button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import md5 from 'md5'
export default {
  data() {
    return {
      // email: 'ivucko@yahoo.com',
      // password: 'vucko123'
      email: '',
      password: ''
    }
  },
  created() {
    //this.$refs.email.$el.focus()
  },
  methods: {
    onSubmit() {
      // console.log('onSubmit')
      this.$store
        .dispatch('auth/login', {
          email: this.email,
          password: md5(md5(this.password))
        })
        .then(() => {
          this.$router.push({ name: 'Vesti' })
        })
        .catch(error => {
          console.log(error)
          this.$buefy.snackbar.open({
            message: 'Неупешна пријава!',
            type: 'is-danger'
          })
        })
    }
  }
}
</script>
